<template>
  <div class="container">
    <div class="bookshelft-header-div">
      <span class="bookshelf-header">我的图书馆</span>
      <div class="list-search-container">
        <span class="search" @click="showSearch = !showSearch">搜索</span>
      </div>
    </div>
    <div class="search-wrapper" v-show="showSearch">
      <div class="search-wrapper__box">
        <span class="label">作品名称:</span>
        <el-input v-model="searchData.queryTitle" class="name">
          <i slot="prefix" class="el-input__icon"></i>
        </el-input>
      </div>
      <div class="search-wrapper__box">
        <span class="label">创建时间:</span>
        <el-date-picker v-model="searchData.createTimeStart" value-format="yyyy-MM-dd" type="date" placeholder="开始日期"> </el-date-picker>
        <span>至</span>
        <el-date-picker v-model="searchData.createTimeEnd" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"> </el-date-picker>
      </div>
      <div class="search-wrapper__box__btn">
        <span class="search" @click="query(searchData.queryTitle)">搜索</span>
        <span class="reset" type="info" size="mini" @click="reset('')">重置</span>
      </div>
    </div>
    <LibPublished ref="LibPublished" :shelfLibData="libData" @changePage="changePage" @libBuildCon="libBuildCon"></LibPublished>
  </div>
</template>

<script>
import LibPublished from './LibPublished'
import BookLibInterface from '@api/bookLib'
import { mapState } from 'vuex'
export default {
  name: 'publishedIndex',
  data() {
    return {
      libData: {
        userType: '图书馆',
        dataList: [], //图书馆列表信息
        isShelf: false, //true代表专辑，false代表图书馆
        totalCount: null //图书馆列表总数
      },
      searchData: {
        queryTitle: '',
        createTimeEnd: '',
        createTimeStart: ''
      },
      showSearch: false,
      time: ''
    }
  },
  components: {
    LibPublished
  },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    userName() {
      return localStorage.getItem('username')
    }
  },
  watch: {
    booksCurrentSubAccount() {
      this.getBookLibList(1)
    }
  },
  created() {
    this.getBookLibList(1)
  },
  methods: {
    // 获取图书馆列表
    getBookLibList(pageNo) {
      // pageNo页号 pageSize每页记录数
      let param = {
        pageNo: pageNo,
        pageSize: 11,
        username: this.booksCurrentSubAccount !== '' ? this.booksCurrentSubAccount : this.userName,
        libName: this.searchData.queryTitle,
        createTimeStart: this.searchData.createTimeStart,
        createTimeEnd: this.searchData.createTimeEnd
      }
      BookLibInterface.getBookLibList(param).then((res) => {
        if (res.status == 200) {
          this.libData.dataList = res.data.page.result
          this.libData.totalCount = res.data.page.totalCount
        }
      })
    },
    // 翻页
    changePage(page) {
      this.getBookLibList(page)
    },
    libBuildCon(params) {
      BookLibInterface.setBookLib(params).then((res) => {
        if (res.status == 200) {
          this.getBookLibList(1)
        }
      })
    },
    query(val) {
      this.searchData.queryTitle = val
      this.time = ''
      this.getBookLibList(1)
      this.$refs.LibPublished.currentPageNo = 1
    },
    reset() {
      this.searchData.queryTitle = ''
      this.searchData.createTimeEnd = ''
      this.searchData.createTimeStart = ''
      this.getBookLibList(1)
      this.$refs.LibPublished.currentPageNo = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.bookshelft-header-div {
  display: flex;
  padding: 8px 10px 8px 0;
  font-size: 17px;
  color: #000;
  font-weight: 400;
  .list-search-container {
    height: 30px;
    margin-left: auto;

    /deep/ {
      .el-input {
        width: 170px;
        //position: relative;
      }
      .el-input__inner {
        height: 24px;
      }
      .el-input__prefix {
        top: -7px;
      }
    }

    span {
      display: inline-block;
      height: 100%;
      margin-right: 5px;
      cursor: pointer;
      width: 102px;
      color: #fff;
      background: #df5813;
      font-size: 20px;
      border-radius: 5px;
      text-align: center;
      line-height: 30px;
    }
    span.search {
      position: relative;
      left: -3px;
      height: 20px;
      width: 80px;
      line-height: 20px;
      font-size: 16px;
    }
    .reset {
      background-color: #999999;
      width: 60px;
      border-radius: 5px;
    }
  }
}
.search-wrapper {
  width: 100%;
  display: flex;
  gap: 36px;
  &__box {
    //width: 300px;
    .el-input {
      width: 146px !important;
      /deep/.el-input__inner {
        width: 100%;
        height: 29px;
        padding-left: 30px;
      }
      /deep/.el-input__prefix {
        top: -5px;
      }
    }
    .name {
      width: 242px !important;
      /deep/.el-input__inner {
        padding-left: 5px;
      }
    }
    /deep/.el-date-editor {
      height: 29px;
    }
    /deep/.el-range-input {
      width: 130px;
      margin-left: 3px;
    }
    /deep/.el-range__icon {
      margin-left: -10px;
      margin-bottom: 10px;
    }
    /deep/.el-range-separator {
      margin-bottom: 10px;
    }
    .label {
      margin-right: 10px;
      color: rgba(153, 153, 153, 1);
    }
    span:not(.label) {
      margin: 0 5px;
    }
    &__btn {
      span {
        display: inline-block;
        height: 29px;
        margin-right: 5px;
        cursor: pointer;
        width: 73px;
        color: #fff;
        line-height: 29px;
        background: #df5813;
        font-size: 13px;
        border-radius: 5px;
        text-align: center;
      }
      span.search {
        position: relative;
        left: -3px;
      }
      span:not(.search) {
        background: rgba(153, 153, 153, 1);
      }
    }
  }
}
</style>
